import { Routes, Route, Navigate } from "react-router-dom"
import DashBoard from "../page/DashBoard"
import EnergyTrading from "../page/EnergyTrading"
import Layout from "../page/Layout"
import EnergyMornitoring from "../page/EnergyMornitoring"
import RenewableEnergyMornitoring from "../page/RenewableEnergyMornitoring"

export default function MainRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/" element={<Layout />}>
        <Route path="/" element={<DashBoard />} />
        <Route path="/energy-monitoring" element={<EnergyMornitoring />} />
        <Route
          path="/renewable-energy-monitoring"
          element={<RenewableEnergyMornitoring />}
        />
        <Route path="/energy-trading" element={<EnergyTrading />} />
      </Route>
    </Routes>
  )
}
